import _construct from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/construct";
import TouchRipple from './touch-ripple-class';
export default {
  name: 'touch-ripple',
  static: {
    TouchRipple: TouchRipple
  },
  create: function create() {
    var app = this;
    app.touchRipple = {
      create: function create() {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _construct(TouchRipple, args);
      }
    };
  }
};